import { FormikErrors, FormikTouched, getIn } from 'formik';

export const getNestedError = (name: string, errors: FormikErrors<any>, touched: FormikTouched<any>) => {
  const error = getIn(errors, name);
  const touch = getIn(touched, name);

  return touch && error ? error : null;
};
